import { styled } from "@mui/material/styles";
import { Box, Button } from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    borderRadius: "8px",
}));

export const HeaderRow = styled(Box)(() => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
}));

export const Title = styled("h6")(({ theme }) => ({
    color: "black",
    margin: 0,
    fontSize: "1.25rem",
    fontWeight: 500,
    fontFamily: theme.typography.fontFamily,
}));

export const UploadButton = styled(Button)(() => ({
    border: "2px dashed gray",
    color: "black",
    background: "white",
    fontWeight: "bold",
    "&:hover": {
        background: "#f5f5f5",
    },
}));

export const FileRow = styled(Box)(() => ({
    border: "3px dashed gray",
    borderRadius: "6px",
    padding: "8px 12px",
    marginBottom: "10px",
    background: "white",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
}));
